export const buttonState = {
  LOADING: 'loading',
  ERRORED: 'errored',
  AVAILABLE: 'available',
  UNAVAILABLE: 'unavailable',
}

export const errorColors = {
  DARK_GREY: '#9096A8',
  LIGHT_GREY: '#D5D8E2',
}
